import { getColor, MessageType } from 'components/Common/util/getColor.util';
import * as React from 'react';
import styled from 'styled-components';

export type TVariants = 'span' | 'div';

export type JRCCardProps = React.ComponentPropsWithoutRef<'div'> & {
    variant?: TVariants;
    type?: MessageType;
    padding?: PaddingValues;
};

export type PaddingValues = keyof typeof PADDING;

export const PADDING = {
    mini: '0px',
    small: '4px',
    base: '8px',
    medium: '12px',
    large: '16px',
};

export const Card = styled.div<{ type?: MessageType; padding?: PaddingValues }>`
    border-radius: 8px;
    background: ${(props) => (props.type ? props.theme.color[getColor(props.type)] : 'white')};
    padding: ${(props) => (props.padding ? PADDING[props.padding] : PADDING.base)};
    margin: 0 8px 16px;
    overflow: hidden;
`;

export const JRCCard = (props: JRCCardProps) => {
    const { variant, ...otherProps } = props;

    return <Card as={variant} {...otherProps} />;
};
